import { render, staticRenderFns } from "./FilterSubIds.vue?vue&type=template&id=72b11839&scoped=true&"
import script from "./FilterSubIds.vue?vue&type=script&lang=ts&"
export * from "./FilterSubIds.vue?vue&type=script&lang=ts&"
import style0 from "./FilterSubIds.vue?vue&type=style&index=0&id=72b11839&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b11839",
  null
  
)

export default component.exports